import { render, staticRenderFns } from "./StudentLayout.vue?vue&type=template&id=2bcaa976&scoped=true&"
import script from "./StudentLayout.vue?vue&type=script&lang=js&"
export * from "./StudentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcaa976",
  null
  
)

export default component.exports